import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Input, Label, Alert } from "reactstrap";
import { Link } from "react-router-dom";

import axiosInstance from "src/common/axiosInstance";
import useAgencyData from "../../common/useAgencyData";
import { useLocation } from "react-router-dom";
const ForgetPasswordPage = () => {
    const location = useLocation();
    const errorMsg = location.state?.message;
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [internalUserMessage, setInternalUserMessage] = useState("");
    const { agencyName, agencyLogo, agencyId, domain } = useAgencyData();
    useEffect(() => {
        if(errorMsg)
            setError(errorMsg);
    },[])
    const handleEmailChange = (e: any) => {
        setEmail(e.target.value);
    };

    const handleFormSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axiosInstance.post(`/forgot-password`, {
                email,
            });
            setLoading(false);
            if(response.data.data.isInternalUser){
                setInternalUserMessage(response.data.data.message);
                setMessage("");
                setError("");
            } else if(response.data.data.flag){
                setMessage(response.data.data.message);
                setError("");
                setInternalUserMessage("");
            } else {
                setError(response.data.data.message);
                setMessage("");
                setInternalUserMessage("");
            }
        } catch (err) {
            setLoading(false);
            setError("Something went wrong. Please try again.");
            setMessage("");
            setInternalUserMessage("");
        }
    };

    return (
        <React.Fragment>
            <div className="authentication-bg min-vh-100">
                <div className="bg-overlay bg-white"></div>
                <Container>
                    <div className="d-flex flex-column min-vh-100 px-3 pt-4">
                        <Row className="justify-content-center my-auto">
                            <Col md={8} lg={6} xl={4}>
                                <div className="text-center py-5">
                                    <div className="mb-4 mb-md-5">
                                        <Link to="/analytics" className="d-block auth-logo">
                                            <img
                                                src={agencyLogo}
                                                alt=""
                                                height="60"
                                                className="auth-logo-dark"
                                            />
                                        </Link>
                                    </div>
                                    <div className="text-muted mb-4">
                                        <h5 className="">Reset Password</h5>
                                    </div>
                                    {message && <Alert color="success" className="text-center mb-4" role="alert">{message}</Alert>}
                                    {error && <Alert color="danger" className="text-center mb-4" role="alert">{error}</Alert>}
                                    {internalUserMessage && (
                                        <Alert color="warning" className="text-center mb-4" role="alert">
                                            <i className="uil uil-info-circle me-1"></i>
                                            {internalUserMessage}
                                        </Alert>
                                    )}
                                    <Form onSubmit={handleFormSubmit}>
                                        <div className="form-floating form-floating-custom text-start mb-3">
                                            <Input
                                              type="email"
                                              className="form-control"
                                              id="input-email"
                                              placeholder="Enter Email"
                                              value={email}
                                              onChange={handleEmailChange}
                                              required
                                            />
                                            <Label htmlFor="input-email">Email</Label>
                                            <div className="form-floating-icon">
                                                <i className="uil uil-envelope-alt"></i>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <button type="submit" className="btn btn-info w-100" disabled={loading}>
                                                {loading ? (
                                                  <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                  "Send Request"
                                                )}
                                            </button>
                                        </div>
                                         <div className="mt-4">
                                            <Link
                                            to="/login"
                                            className="text-muted text-decoration-underline"
                                            >
                                             Back to Login
                                            </Link>
                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ForgetPasswordPage;
